if (typeof ShippingNotice !== 'function') {

  class ShippingNotice extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      setTimeout(() => {
        const cartForm = document.querySelector('cart-form');

        if (cartForm && !document.querySelector('#forced-shipping-message')) {
          const msg = document.createElement('div');
          msg.id = 'forced-shipping-message';
          msg.className = 'cart-notice text-size--small';
          
          msg.style.cssText = `
            margin-bottom: 16px;
            padding: 12px 16px;
            background-color: transparent;
            border: none;
            border-bottom: 1px solid rgba(26,23,20,0.08);
            border-radius: 0;
            font-size: 11px;
            font-weight: 500;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: #B8976E;
            text-align: center;
          `;
          
          msg.innerHTML = 'You are eligible for free shipping';
          cartForm.prepend(msg);
        }

        const progressBar = document.querySelector('.cart__progress-bar span');
        if (progressBar) {
          progressBar.style.width = '100%';
          progressBar.classList.remove('hidden', 'opacity-0');
        }

        const checkmark = document.querySelector('.cart__free-shipping-check');
        if (checkmark) {
          checkmark.classList.add('is-visible');
          checkmark.classList.remove('hidden', 'opacity-0');
          checkmark.style.display = 'inline-block';
        }

        const slider = document.querySelector('[data-js-free-shipping-slider]');
        if (slider) {
          slider.style.width = '100%';
          slider.classList.remove('hidden', 'opacity-0');
        }

      }, 1000);
    }
  }

  if (typeof customElements.get('shipping-notice') === 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }
}